import App from './App.svelte';

const anchor = document.getElementsByClassName("search-anchor")[0];

const app = new App({
	target: document.getElementsByTagName("main")[0],
	anchor: anchor,
	props: {}
});

export default app;